import React, { useState, useEffect, useMemo } from 'react';

import ReactBnbGallery from 'react-bnb-gallery';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';

import 'react-bnb-gallery/dist/style.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { CarrosselContainer, ContainerImagem } from './carrossel-styled';
import { AdImageNotFoundSVG } from '../../utils/icons';
import ImageWithFallback from '../ImageWithFallback';

const Carrossel = ({ anuncio }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(0);
    const [isShortWidth, setIsShortWidth] = useState(false);

    const validateImagePerView = (image) => (image > 3 ? 3 : image);

    const imagens = useMemo(() => {
        if (anuncio.imagens.length < 3) {
            const newImagens = [];

            anuncio.imagens.forEach((element) => {
                newImagens.push(element);
            });

            while (newImagens.length < 3) {
                newImagens.push({
                    imageUrl: AdImageNotFoundSVG,
                    isDefault: true,
                });
            }

            return newImagens;
        } else {
            return anuncio.imagens;
        }
    }, [anuncio.imagens]);

    useEffect(() => {
        setIsShortWidth(window.innerWidth < 768);
    }, [isShortWidth]);


    return (
        <>
            <CarrosselContainer imageLength={imagens.length}>
                <Swiper
                    breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 1,
                            slidesPerGroup: 1,
                            loopFillGroupWithBlank: false,
                        },
                        768: {
                            slidesPerView: validateImagePerView(imagens.length),
                            spaceBetween: 3,
                            slidesPerGroup: 2,
                            loopFillGroupWithBlank: false,
                            allowTouchMove: false,
                        },
                        1024: {
                            slidesPerView: validateImagePerView(imagens.length),
                            spaceBetween: 4,
                            slidesPerGroup: 3,
                            loopFillGroupWithBlank: true,
                            allowTouchMove: false,
                        },
                    }}
                    pagination={{
                        dynamicBullets: true,
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiper"
                >
                    {imagens?.map((item, index) => {
                        let blockClick = false;
                        return (
                            <SwiperSlide key={item.id}>
                                <ContainerImagem>
                                    <div
                                        onClick={() => {
                                            if (
                                                !item.isDefault &&
                                                !blockClick
                                            ) {
                                                setIsOpen(true);
                                                setSelectedImage(index);
                                            }
                                        }}
                                    >
                                        <ImageWithFallback
                                            onHasError={() =>
                                                (blockClick = true)
                                            }
                                            src={item.imageUrl}
                                            fallbackSrc={AdImageNotFoundSVG}
                                            objectFit="cover"
                                            layout="fill"
                                            alt="imagem do imóvel"
                                        />
                                    </div>
                                </ContainerImagem>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                {isOpen === true && (
                    <ReactBnbGallery
                        phrases={{
                            showPhotoList: 'Mostrar lista',
                            hidePhotoList: 'Esconder lista',
                        }}
                        show={isOpen}
                        onClose={() => setIsOpen(false)}
                        photos={anuncio.imagens.map((item) => item.imageUrl)}
                        activePhotoIndex={selectedImage}
                    />
                )}
            </CarrosselContainer>
        </>
    );
};

export default Carrossel;
